import React, { useCallback, useState } from 'react'
import styles from 'components/panels/empty-panel.module.scss'
import cn from 'classnames'
import FilterOptions from 'components/filters/FilterOptions'
import { isMobile } from 'lib/device'
import useStore from 'state/knovStore'
import usePanelContext from 'refactor/hooks/usePanelContext'
import useStreamFilters from 'components/filters/useStreamFilters'
import NewQuestButton from 'components/quests/NewQuestButton'
import useRemovePanel from 'refactor/hooks/useRemovePanel'
import SearchIcon from 'components/shared/icons/SearchIcon'
import TreechatIconPng from 'components/shared/icons/TreechatIconPng'

export default React.memo(function EmptyPanel() {
    const { panel, hide } = usePanelContext()

    const { selectHistory, selectStarred, selectAll } = useStreamFilters(panel.panelId, {
        append: false,
    })

    const panelId = panel.panelId
    const panels = useStore.getState().panels
    const [showFilterOptions, setShowFilterOptions] = useState(false)
    const removePanel = useRemovePanel()
    const onRemovePanel = useCallback(ev => removePanel(), [])

    const panelIx = panels.getIndexById(panelId)
    const canRemove =
        panelIx !== 0 && panelIx !== panels.state.length - 1 && panels.state.length > 3

    return (
        <div
            style={{ visibility: hide ? 'hidden' : 'visible' }}
            className={cn(
                styles.emptyPanelComp,
                showFilterOptions && styles.activePanel,
                'empty-panel-comp',
            )}
        >
            {true && (
                <div
                    className={cn(
                        styles.streamControlContainer,
                        showFilterOptions && styles.activeContainer,
                        isMobile && styles.mobileStreamControlContainer,
                    )}
                    onClick={() => setShowFilterOptions(!showFilterOptions)}
                >
                    {true && (
                        <div
                            className={cn(
                                styles.filterOptionsContainer,
                                isMobile && styles.emptyPanelMobileFilterOptionsContainer,
                                showFilterOptions && styles.activeFilterContainer,
                            )}
                        >
                            <FilterOptions
                                origin="empty-panel"
                                close={() => setShowFilterOptions(!showFilterOptions)}
                                header={'Choose Channel'}
                                show={[
                                    'home',
                                    'private',
                                    'streams',
                                    'memes',
                                    'notifications',
                                    'user',
                                    'search',
                                    'ordinals',
                                    'market',
                                    'starred',
                                    'history',
                                    //'links',
                                    'clips',
                                    'teams',
                                    'account',
                                ]}
                                contextStyles={cn(
                                    styles.filterOptions,
                                    isMobile && styles.mobileFilterOptions,
                                )}
                                showNoti
                                append={false}
                                panelId={panelId}
                            />
                        </div>
                    )}

                    <div className={cn(styles.control, showFilterOptions && styles.activeControl)}>
                        <TreechatIconPng contextStyles={styles.treechatIcon} />
                    </div>
                </div>
            )}

            {canRemove && (
                <div className={styles.controlContainer} onClick={onRemovePanel}>
                    <div className={cn(styles.control, styles.removePanel)}>
                        <i className="fa fa-remove" />
                    </div>
                </div>
            )}
        </div>
    )
})
